<template>
  <div class="svg-body">
    <div v-html="svgHtml"></div>
  </div>
</template>

<script>
import $ from 'jquery';
import svgPanZoom from '../utils/svg-pan-zoom';

export default {
  props: {
    svgHtml: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      svgBlockElement: null,
    };
  },
  methods: {
    init() {
      this.svgBlockElement = $('.svg-block');
      setTimeout(() => {
        this.initZoom();
        this.onClickBlock();
      }, 1000);
    },
    onClickBlock() {
      this.svgBlockElement.unbind('click');
      this.svgBlockElement.on('click', (event) => {
        const { id } = event.currentTarget;
        this.$emit('on-select-block', { id });
      });
    },
    initZoom() {
      svgPanZoom('#svgZoom');
    },
  },
};
</script>

<style lang="scss">
.svg-block{
  cursor: pointer;
}
.svg-body {
  height: 65vh;
  padding: 0;
  background: #fff;
  box-shadow: inset 0 5px 10px rgba(#000, 0.2);
  svg{
    width: 100%;
    height: 64vh;
  }
}
</style>
